import { numberSchema, stringSchema, urlSchema, objectSchema } from '@/schemas'

export const projectFileSchema = objectSchema({
  id: numberSchema,
  name: stringSchema,
  file_name: stringSchema,
  original: urlSchema,
  preview: urlSchema,
  thumb: urlSchema,
})
